"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _conductor = require("@virtuous/conductor");

var _Route2 = _interopRequireDefault(require("../Route"));

var _Route3 = _interopRequireDefault(require("./components/Route"));

var _context = require("../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The SpringGroup component.
 */
var SpringGroup =
/*#__PURE__*/
function (_Route) {
  _inherits(SpringGroup, _Route);

  function SpringGroup() {
    _classCallCheck(this, SpringGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(SpringGroup).apply(this, arguments));
  }

  _createClass(SpringGroup, [{
    key: "render",

    /**
     * @returns {JSX}
     */
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          className = _this$props.className,
          component = _this$props.component,
          spring = _this$props.spring;
      var routes = this.matchingRoutes;
      return routes.map(function (entry) {
        var current = entry.index === _conductor.router.routeIndex;

        var _entry$route = entry.route,
            transform = _entry$route.transform,
            context = _objectWithoutProperties(_entry$route, ["transform"]);

        context.open = true;
        context.visible = true;
        var key = "".concat(entry.route.id, "-").concat(entry.route.pathname);
        return _react["default"].createElement(_context.RouteContext.Provider, {
          key: key,
          value: context
        }, _react["default"].createElement(_Route3["default"], {
          className: className,
          component: component,
          current: current,
          index: entry.index,
          spring: spring,
          prevRoute: _this.context.prev,
          nextRoute: _this.context.next
        }));
      });
    }
  }, {
    key: "matchingRoutes",

    /**
     * @returns {Object}
     */
    get: function get() {
      var pattern = this.props.pattern;
      var matches = [];

      var prev = _conductor.stack.get(this.context.prev);

      var next = _conductor.stack.get(this.context.next);

      if (prev && prev.pattern === pattern) {
        var index = this.context.stack.findIndex(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
              id = _ref2[0];

          return id === prev.id;
        });
        matches.push({
          index: index,
          route: prev
        });
      }

      if (next && next.pattern === pattern) {
        var _index = this.context.stack.findIndex(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 1),
              id = _ref4[0];

          return id === next.id;
        });

        matches.push({
          index: _index,
          route: next
        });
      }

      return matches;
    }
  }]);

  return SpringGroup;
}(_Route2["default"]);

_defineProperty(SpringGroup, "propTypes", _objectSpread({}, _Route2["default"].propTypes, {
  spring: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string
}));

var _default = SpringGroup;
exports["default"] = _default;